import { environment } from '../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('HotelService', HotelService);

  HotelService.$inject = [
    'RestResource',
    'CONFIGURATIONS',
    '$translate',
    '$filter',
    'UtilService',
    'HotelModalService',
    'SessionService',
  ];

  function HotelService(
    RestResource,
    config,
    $translate,
    $filter,
    UtilService,
    HotelModalService,
    SessionService
  ) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'hotels';

    var service = {
      getFilterCriteria: getFilterCriteria,
      getHotels: getHotels,
      getHotel: getHotel,
      saveHotel: saveHotel,
      deleteHotel: deleteHotel,
      changeHotelStatus: changeHotelStatus,
      openHotelListModal: openHotelListModal,

      setDefaultAssociatedProvider: setDefaultAssociatedProvider,
      getHotelAvailabilitySchedule: getHotelAvailabilitySchedule,
    };

    return service;

    ////////////////

    function getFilterCriteria() {
      var filterCriteria = {
        page: 1,
        sortDir: 'asc',
        sortedBy: 'name',
      };

      return filterCriteria;
    }

    function getHotels(filterCriteria) {
      if (!filterCriteria) {
        filterCriteria = getFilterCriteria();
      }

      filterCriteria.company_id = SessionService.getSelectedAccountCompany().id;

      return RestResource.request(
        'get',
        apiUrl,
        filterCriteria,
        function (response) {
          response = response.data;

          if (response.meta) {
            return {
              items: response.data,
              meta: utils.getItemsMetaData(response, filterCriteria),
            };
          } else {
            return {
              items: response,
            };
          }
        },
        {}
      );
    }

    function getHotel(id, filterCriteria) {
      if (!filterCriteria) {
        filterCriteria = {};
      }

      return RestResource.request(
        'get',
        apiUrl + '/' + id,
        filterCriteria,
        function (response) {
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function saveHotel(item) {
      var method = 'post';

      var url = apiUrl;
      if (item.id) {
        // edit
        url += '/' + item.id;
        method = 'put';
      }

      function success(response) {
        var msg = !item.id ? 'HOTEL_ADDED' : 'HOTEL_MODIFIED';
        utils._successMsg($translate(msg));

        return {
          status: true,
          response: response.data,
        };
      }

      function failure(response) {
        return {
          status: false,
          response: response.data,
        };
      }

      return RestResource.request(method, url, { hotel: item }, success, failure);
    }

    function deleteHotel(item, successCallback) {
      let url = apiUrl + '/' + item.id;

      return RestResource.request(
        'delete',
        url + '?check_if_used=true',
        {},
        function () {
          let params = {
            title: 'DELETE_HOTEL',
            itemName: item.name,
            reason: 'DELETE_ITEM_REASON',
            successMsg: 'HOTEL_DELETED',
          };

          utils.deleteItem(url, successCallback, params);
        },
        function (response) {
          utils.openModalError(response.data.error);
        }
      );
    }

    function changeHotelStatus(item) {
      let url = apiUrl + '/' + item.id + '?set_status=true';

      let newStatus = item.status === config.ACTIVE ? config.INACTIVE : config.ACTIVE;

      let params = {
        check_if_used: true,
        status: newStatus,
      };

      return RestResource.request(
        'put',
        url,
        params,
        function () {
          utils.changeItemStatus(url, item);
        },
        function (response) {
          utils.openModalError(response.data.error);
        }
      );
    }

    function openHotelListModal(websiteId) {
      // hotelIds
      HotelModalService.openHotelListModal(websiteId); // hotelIds
    }

    function setDefaultAssociatedProvider(providerId, hotelId, successCallback) {
      var url = apiUrl + '/' + hotelId + '/set_default_associated_provider';

      return RestResource.request(
        'put',
        url,
        { provider_id: providerId },
        function (response) {
          var msg = $translate('DEFAULT_PROVIDER_CHANGED');
          utils._successMsg(msg);

          return successCallback(providerId);
        },
        function (response) {
          utils._errorMsg(response.data.error);
          return false;
        }
      );
    }

    function getHotelAvailabilitySchedule(id, filterCriteria) {
      return RestResource.request(
        'get',
        apiUrl + '/' + id + '/get_hotel_availability_schedule',
        filterCriteria,
        function (response) {
          return response;
        },
        function () {
          return false;
        }
      );
    }
  }
})();
